import '../assets/NcActionCaption-BNDtcWJ7.css';
import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcActionCaption",
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: false
    }
  },
  props: {
    /**
     * The caption's text
     */
    name: {
      type: String,
      required: true
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("li", { staticClass: "app-navigation-caption", attrs: { "role": _vm.isInSemanticMenu && "presentation" } }, [_vm._v(" " + _vm._s(_vm.name) + " ")]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "7bf21eca"
);
const NcActionCaption = __component__.exports;
export {
  NcActionCaption as default
};
//# sourceMappingURL=NcActionCaption.mjs.map
